module.exports = {"pathContext":{"name":"Float","kind":"SCALAR","type":"OBJECT","fields":null,"description":"The `Float` scalar type represents signed double-precision fractional\nvalues as specified by\n[IEEE 754](https://en.wikipedia.org/wiki/IEEE_754).","enumValues":null,"possibleTypes":null}}


//////////////////
// WEBPACK FOOTER
// ./~/json-loader!./.cache/json/scalar-float.json
// module id = 2127
// module chunks = 65850540693356